const styles = {
    container: {
        maxWidth: '100%',
        mt: '24px',
    },
    title: {
        fontFamily: 'Silka_Bold',
        fontWeight: 700,
        fontSize: '32px',
        lineHeight: '48px',
        color: '#090C39',
        textTransform: 'capitalize',
    },
    subTitle: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '24px',
        lineHeight: '36px',
        color: '#8697AB',
    },
    divider: {
        color: '#E0E4ED',
        marginTop: '32px',
        marginBottom: '32px',
    },
    table: {
        padding: '24px',
        borderRadius: '16px',
        mt: 3,
        boxShadow: '0px 30px 30px rgba(151, 172, 191, 0.08), 0px 0px 30px rgba(151, 172, 191, 0.12)',
    },
    count: {
        background: '#FFFFFF',
        color: '#8697AB',
        padding: '4px',
        borderRadius: '8px',
        ml: 2,
    },
    header: {
        display: 'flex',
        alignItems: 'center',
    },
    selectedFilters: {
        gap: '20px',
    },
    chip: {
        borderRadius: '4px',
        fontSize: '12px',
        fontFamily: 'SILKA_REGULAR',
        lineHeight: '16px',
        height: '24px',
        backgroundColor: 'rgba(61, 135, 191, 0.1)',
        borderWidth: 0,
    },
    chipDelete: {
        mt: '-10px !important',
    },
    admin: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        gap: '10px',
        alignItems: 'center',
    },
    addAdmin: {
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#3876AA',
        marginLeft: 'auto',
    },
    addAdminButton: {
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#3876AA',
        marginLeft: 'auto',
        width: '164px',
        height: '48px',
        borderRadius: '16px',
    },
    addIcon: {
        ml: 1,
        alignItems: 'center',
    },
};
export default styles;
